export default __webpack_public_path__ + "static/open-devtools-ee62d4d2fcda6a3cb98d27d1fcb55577.png";